import React, { PropTypes } from 'react';
import MobileMenuContainer from '../../../containers/MobileMenuContainer';
import Wideskyscrapper from '../ads/Wideskyscrapper';

const propTypes = {
  locale: PropTypes.string.isRequired,
  children: PropTypes.element,
  onLocaleChange: PropTypes.func.isRequired,
};

const MainContainer = (props) => (
  <section className="divided row">
    <main className="thirteen wide computer sixteen wide tablet column">
      <MobileMenuContainer />
      <div className="ui grid">
        <div className="column">
          {
            props.children &&
            React.cloneElement(props.children, { onLocaleChange: props.onLocaleChange })
          }
        </div>
      </div>
    </main>
    <Wideskyscrapper locale={props.locale} />
  </section>
);

MainContainer.propTypes = propTypes;

export default MainContainer;



/** WEBPACK FOOTER **
 ** ./src/components/layout/main/Main.js
 **/